import { useModel as _useModel, mergeModels as _mergeModels, defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, isRef as _isRef, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode } from "vue"

import {ITextField} from "~/cabinet/vue/interface/form/elements/Interfaces";
import ChatFormButton from "~/chat/vue/widget/form/fields/ChatFormButton.vue";


const __default__ = {
    name: "ChatTextInputSuggest"
}

export default /*@__PURE__*/_defineComponent({
  ...__default__,
  props: /*@__PURE__*/_mergeModels({
    field: {}
  }, {
    "modelValue": {},
    "modelModifiers": {},
  }),
  emits: ["update:modelValue"],
  setup(__props: any) {



let model = _useModel<string>(__props, "modelValue")


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _renderSlot(_ctx.$slots, "default"),
    (_ctx.field.suggest && _ctx.field.suggest.length)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: _normalizeClass(['suggest-wrapper', !_unref(model) ? 'empty-value' : null])
        }, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.field.suggest, (item, index) => {
            return (_openBlock(), _createElementBlock("div", {
              key: index,
              class: "mt-2"
            }, [
              _createVNode(ChatFormButton, {
                inverse: "",
                type: "primary",
                round: "",
                onClick: ($event: any) => (_isRef(model) //@ts-ignore
 ? model.value = item.value : model = item.value),
                class: "suggest"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(item.descr), 1)
                ]),
                _: 2
              }, 1032, ["onClick"])
            ]))
          }), 128))
        ], 2))
      : _createCommentVNode("", true)
  ]))
}
}

})